// Mock data for Midbrothers clone

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1713098965471-d324f294a71d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHx3b3JsZCUyMG1hcHxlbnwwfHx8Ymx1ZXwxNzkwODAxMTM1fDA&ixlib=rb-4.1.0&q=85',
  methodology: 'https://images.unsplash.com/photo-1543286386-2e659306cd6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGdyb3d0aHxlbnwwfHx8fDE3OTA4MDExMzV8MA&ixlib=rb-4.1.0&q=85',
  passive: 'https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBjb25zdWx0aW5nfGVufDB8fHx8MTc5MDgwMTEzNXww&ixlib=rb-4.1.0&q=85',
  growth: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGdyb3d0aHxlbnwwfHx8fDE3OTA4MDExMzV8MA&ixlib=rb-4.1.0&q=85',
  startup: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxzdGFydHVwJTIwY29uc3VsdGluZ3xlbnwwfHx8fDE3OTA4MDExMzV8MA&ixlib=rb-4.1.0&q=85',
  team: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxzdGFydHVwJTIwY29uc3VsdGluZ3xlbnwwfHx8fDE3OTA4MDExMzV8MA&ixlib=rb-4.1.0&q=85',
};

export const SERVICES = [
  {
    id: 'financial-consulting',
    title: 'FINANCIAL CONSULTING',
    desc: 'Expert advice for financial success. Customized strategies for individuals and businesses.',
    icon: 'Briefcase',
  },
  {
    id: 'investment',
    title: 'INVESTMENT',
    desc: 'Strategic financial solutions for growth. Building wealth, one investment at a time.',
    icon: 'TrendingUp',
  },
  {
    id: 'book-publishing',
    title: 'BOOK PUBLISHING',
    desc: 'Turning your ideas into reality. Expert guidance for authors and publishers.',
    icon: 'BookOpen',
  },
  {
    id: 'retirement-planning',
    title: 'RETIREMENT PLANNING',
    desc: 'Secure your future with smart planning. Comprehensive financial strategies for every stage of life.',
    icon: 'Umbrella',
  },
  {
    id: 'it-consulting',
    title: 'IT CONSULTING',
    desc: 'Innovating technology to drive success. Tailored IT strategies for business growth.',
    icon: 'Cpu',
  },
  {
    id: 'target-marketing',
    title: 'TARGET MARKETING',
    desc: 'Podcasting operational change management inside of workflows to establish a framework for taking action.',
    icon: 'Target',
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    text: 'A solid choice for those looking to explore investment opportunities with a user-friendly interface.',
    name: 'John Smith',
    role: 'Investor',
  },
  {
    id: 2,
    text: 'Leveraging accessible opportunities to identify value-added activities offers a smart approach for beta testing potential returns.',
    name: 'James Rods',
    role: 'Investor',
  },
  {
    id: 3,
    text: 'The platform does a great job addressing the digital divide, making investment services more inclusive and easier to navigate for a wider audience.',
    name: 'Caroline Marry',
    role: 'Investor',
  },
];

export const STARTUP_FEATURES = [
  'Valuation Services',
  'Development of Financial Models',
  'Corporate Financial Advisory',
  'Deal Structuring',
  'Feasibility Studies & Business Plans',
];

export const SERVICE_CARDS = [
  {
    id: 'merge',
    title: "LET'S MERGE OUR BUSINESS GOALS",
    desc: 'Merge for scalable growth, enhanced innovation, and seamless financial synergy in fintech.',
    icon: 'GitMerge',
  },
  {
    id: 'startup',
    title: 'BUSINESS PLAN AND STARTUP',
    desc: 'Strategic roadmap for launching, scaling, and sustaining a successful fintech startup.',
    icon: 'Rocket',
  },
  {
    id: 'practical',
    title: 'PRACTICAL STARTUP CONSULTANCY',
    desc: 'Expert guidance for launching, scaling, and optimizing startups with actionable strategies.',
    icon: 'Lightbulb',
  },
  {
    id: 'entrepreneurial',
    title: 'ENTREPRENEURIAL FACILITATION',
    desc: 'Empowering entrepreneurs with resources, mentorship, and strategic support for business success.',
    icon: 'Users',
  },
];

export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '#services' },
  { label: 'About', href: '/about' },
  { label: 'Our Builds', href: '/our-builds' },
  { label: 'Contacts', href: '#contact' },
];

export const CONTACT = {
  email: 'info@midbrothers.com',
  phone: '+39 380 645 7462',
  address: 'Via dei Castani, 157, 00172 Roma RM, Italy',
  hours: '08:00 AM - 05:00 PM',
};

export const COMPANY = {
  registrationNumber: '16239546',
  registeredOffice: '2nd Floor College House, 17 King Edwards Road, Ruislip, London, United Kingdom, HA4 7AE',
};
